import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("autosuggest-input", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-autosuggest-input></ux-autosuggest-input>`);
        const el = await page.find("ux-autosuggest-input");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-autosuggest-input placeholder="test" name="mr-input" input-id="test-id" url="#" />`);
        const el = await page.find("ux-autosuggest-input");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with static suggestions", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `
                <ux-autosuggest-input label="select a country" required placeholder="Enter the land">
                </ux-autosuggest-input>
            `
        );
        await page.waitForChanges();
        const el = await page.find("ux-autosuggest-input");
        el.setProperty("staticSuggestions", [
            { value: "DE", label: "Germany" },
            { value: "IT", label: "Italy" },
            { value: "ES", label: "Spain" },
            { value: "NL", label: "Netherlands" },
            { value: "FR", label: "France" },
            { value: "UK", label: "United Kingdom" },
            { value: "US", label: "United States" },
            { value: "CO", label: "Colombia" },
            { value: "CH", label: "Switzerland" },
            { value: "ZB", label: "Zimbawe" }
        ]);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-autosuggest-input placeholder="test" name="mr-input" input-id="test-id" />`);
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `
            <ux-data-ingest static-suggestions="#countries">
                <ux-autosuggest-input label="select a country" required placeholder="Enter the land">
                </ux-autosuggest-input>
                <script type="application/json" data-id="countries">
                    [
                        { "value": "DE", "label": "Germany" },
                        { "value": "IT", "label": "Italy" },
                        { "value": "ES", "label": "Spain" },
                        { "value": "NL", "label": "Netherlands" },
                        { "value": "FR", "label": "France" },
                        { "value": "UK", "label": "United Kingdom" },
                        { "value": "US", "label": "United States" },
                        { "value": "CO", "label": "Colombia" },
                        { "value": "CH", "label": "Switzerland" },
                        { "value": "ZB", "label": "Zimbawe" }
                    ]
                </script>
            </ux-data-ingest>
            `
        );
    });
});
